import React, { useState, useEffect } from 'react';
import { ArrowUp, MessageCircle } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const FloatingActions = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [showChat, setShowChat] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      {/* Scroll to Top Button */}
      {/* <AnimatePresence>
        {showScrollTop && (
          <motion.button
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.5 }}
            onClick={scrollToTop}
            className="fixed bottom-24 right-6 z-50 w-12 h-12 bg-gradient-to-br from-[#4CAF50] to-[#008000] text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center group hover:scale-110"
            aria-label="Scroll to top"
          >
            <ArrowUp className="w-6 h-6 group-hover:translate-y-[-2px] transition-transform" />
          </motion.button>
        )}
      </AnimatePresence> */}

      {/* WhatsApp Chat Button */}
      <AnimatePresence>
        {showChat && (
          <motion.a
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 50 }}
            href="https://wa.me/919039200574"
            target="_blank"
            rel="noopener noreferrer"
            className="fixed bottom-6 right-6 z-50 group"
          >
            <div className="relative">
              {/* Pulsing Ring */}
              <div className="absolute inset-0 bg-[#25D366] rounded-full animate-ping opacity-75"></div>

              {/* Button */}
              <div className="relative bg-[#25D366] rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 group-hover:scale-110">
                <div className="p-4">
                  <MessageCircle className="w-8 h-8 text-white" />
                </div>
              </div>

              {/* Tooltip */}
              <div className="absolute bottom-full right-0 mb-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="bg-gray-900 text-white px-4 py-2 rounded-lg text-sm whitespace-nowrap shadow-lg">
                  <div className="font-semibold">Chat With</div>
                  <div className="text-xs">Our Experts</div>
                </div>
              </div>
            </div>
          </motion.a>
        )}
      </AnimatePresence>
    </>
  );
};

export default FloatingActions;